import { createFileRoute } from "@tanstack/react-router";

import { PolicyPageLayout } from "#/components/PolicyPageLayout";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";

import { TERMS_LAST_UPDATED, TermsDocument } from "./-terms.document";

export const Route = createFileRoute("/terms")({
  head: () => documentHead(DOCUMENT_TITLES.terms),
  component: TermsPage,
});

function TermsPage() {
  return (
    <PolicyPageLayout
      eyebrow="Legal"
      title="Terms of service"
      description={`Last updated ${TERMS_LAST_UPDATED}. Rules for using Daily Wars, including accounts and Premium subscriptions.`}
    >
      <TermsDocument />
    </PolicyPageLayout>
  );
}
